import { render, staticRenderFns } from "./aggressionResult.vue?vue&type=template&id=dd1d6d06&scoped=true&"
import script from "./aggressionResult.vue?vue&type=script&lang=js&"
export * from "./aggressionResult.vue?vue&type=script&lang=js&"
import style0 from "./aggressionResult.vue?vue&type=style&index=0&id=dd1d6d06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1d6d06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
